export const GET_REFRESH_QR_CODE_CALL = 'GET_REFRESH_QR_CODE_CALL';
export const GET_REFRESH_QR_CODE_DONE = 'GET_REFRESH_QR_CODE_DONE';
export const GET_REFRESH_QR_CODE_FAIL = 'GET_REFRESH_QR_CODE_FAIL';

export const GET_IS_REFRESH_QR_CODE_EXISTS_CALL = 'GET_IS_REFRESH_QR_CODE_EXISTS_CALL';
export const GET_IS_REFRESH_QR_CODE_EXISTS_DONE = 'GET_IS_REFRESH_QR_CODE_EXISTS_DONE';
export const GET_IS_REFRESH_QR_CODE_EXISTS_FAIL = 'GET_IS_REFRESH_QR_CODE_EXISTS_FAIL';
